import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { CompiledChartsModel } from 'common/models/page-models/reports/compiled-reports/compiled-charts-model';
import { CompiledReportsModel } from 'common/models/page-models/reports/compiled-reports/compiled-data-model';
import { CompiledReportsListingModel } from 'common/models/page-models/reports/compiled-reports/compiled-grid-model';
import { CompiledReportsGridPostParams } from 'common/models/page-models/reports/compiled-reports/compiled-grid-params';


@Injectable({
  providedIn: 'root'
})
export class CompiledReportsDataService extends GridDataService<CompiledReportsListingModel, CompiledReportsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.fetchReportData, http, ss);
  }

  createInstance(): CompiledReportsListingModel {
    return new CompiledReportsListingModel();
  }

  getDeleteUrl() {
    return '';
  }

  override getGridParams(param): GridPostParams {
    return new CompiledReportsGridPostParams();
  }

  // override transformDataModel(data: any[], param: any) {
  //   super.transformDataModel(data, param);
  //   console.log(data,param,data.hasOwnProperty(param));
    
  //   if (data.hasOwnProperty(param)) {
  //     data[param].forEach(element => {
  //       console.log(element);
        
  //       element.isKT = element.overallKtStatus === 0 ? 'No' : 'Yes';
  //       // element.avgScore = element.avgScore === 0 ? '0' : element.avgScore;
  //       element.totalScoreInPercentage = element.totalScoreInPercentage === 0 ? '0' : element.totalScoreInPercentage;
  //       // element.scoreTotal = element.totalSemScore
  //       element.totalAssignmentAssigned = element.assignment[0].totalAssignmentAssigned;
  //       element.attended_Student = element.assignment[0].attended_Student
  //       element.avgScore = element.assignment[0].avgScore ?  element.assignment[0].avgScore : '0';
  //     });
  //   }else{
  //     // console.log('No records found for given combination');
  //     this.ss.showError('No records found for given combination')
  //   }
  //   return data;
  // }

  override transformDataModel(data: any[], param: any) {
  try {
    // Call the parent method (if any)
    super.transformDataModel(data, param);

    // Debugging logs
    console.log(data, param, data.hasOwnProperty(param));

    if (data.hasOwnProperty(param)) {
      data[param].forEach(element => {
        console.log(element);
        element.isKT = element.overallKtStatus === 0 ? 'No' : 'Yes';
        element.totalScoreInPercentage = element.totalScoreInPercentage === 0 ? '0' : element.totalScoreInPercentage;
        element.totalAssignmentAssigned = element.assignment.totalAssignmentAssigned;
        element.attended_Student = element.assignment.attended_Student;
        element.avgScore = element.assignment.avgScore ? element.assignment.avgScore : '0';
      });
    } else {
      this.ss.showError('No records found for given combination');
    }

    return data;
  } catch (error) {
    console.error('Error occurred while transforming data:', error);
    this.ss.showError('An error occurred while processing the data. Please try again.');
    return []; 
  }
}


  override modifyGridPostParams(queryParams) {
    let payload = this.getGridParams(queryParams);
    // console.log(queryParams)
    if (queryParams.transferData !== null) {
      payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
      payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
      payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
      payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
      payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
      payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
      payload['location_search'] = queryParams.transferData.selectedLocation === null ? '' : queryParams.transferData.selectedLocation;
      payload['type_search'] = queryParams.transferData.selectedType === null ? '' : queryParams.transferData.selectedType;
      payload['cat_search'] = queryParams.transferData.selectedCategory === null ? '' : queryParams.transferData.selectedCategory;
      payload['attendence_search'] = queryParams.transferData.selectedAttended === null ? '' : queryParams.transferData.selectedAttended;
      payload['fromDate_search'] = queryParams.transferData.selectedFromDate === '' || queryParams.transferData.selectedFromDate === null ? '' : this.formatDateToYYYYMMDD(queryParams.transferData.selectedFromDate);
      payload['toDate_search'] = queryParams.transferData.selectedToDate === '' || queryParams.transferData.selectedToDate === null ? '' : this.formatDateToYYYYMMDD(queryParams.transferData.selectedToDate);
    }
    return payload;
  }

  private formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  override prepareChartsData(apiData) {
    console.log(apiData);
    
    const chartsModel = new CompiledChartsModel();
    let yAxislabel = "Semsters";
    let avgscoreAcademic = 0;
    let avgscoreCredit = 0;
    let averageScore1 = 0;
    let averageScore2 = 0;
    let averageScore3 = 0;
    let averageScore4 = 0;
    let averageScore5 = 0;
    let averageScore6 = 0;
    let averageScore7 = 0;
    let averageScore8 = 0;

    apiData.forEach((key) => {
      // console.log(key);
      averageScore1 = averageScore1 + parseInt(key.semester1);
      averageScore2 = averageScore2 + parseInt(key.semester2);
      averageScore3 = averageScore3 + parseInt(key.semester3);
      averageScore4 = averageScore4 + parseInt(key.semester4);
      averageScore5 = averageScore5 + parseInt(key.semester5);
      averageScore6 = averageScore6 + parseInt(key.semester6);
      averageScore7 = averageScore7 + parseInt(key.semester7);
      averageScore8 = averageScore8 + parseInt(key.semester8);
      avgscoreAcademic = avgscoreAcademic + parseInt(key.scoreTotal);
      avgscoreCredit = avgscoreCredit + parseInt(key.totalCreditScore);

    });
    let studentChartData = [
      {
        name: "sem1",
        y: (averageScore1 / apiData.length) * 10,
        drilldown: "sem1",
        color: "#0E6052",
      },
      {
        name: "sem2",
        y: (averageScore2 / apiData.length) * 10,
        drilldown: "sem2",
        color: "#006F76",
      },
      {
        name: "sem3",
        y: (averageScore3 / apiData.length) * 10,
        drilldown: "sem3",
        color: "#007B9B",
      },
      {
        name: "sem4",
        y: (averageScore4 / apiData.length) * 10,
        drilldown: "sem4",
        color: "#3284BA",
      },
      {
        name: "sem5",
        y: (averageScore5 / apiData.length) * 10,
        drilldown: "sem5",
        color: "#7889CD",
      },
      {
        name: "sem6",
        y: (averageScore6 / apiData.length) * 10,
        drilldown: "sem6",
        color: "#B58AD1",
      },
      {
        name: "sem7",
        y: (averageScore7 / apiData.length) * 10,
        drilldown: "sem7",
        color: "#97B0AA",
      },
      {
        name: "sem8",
        y: (averageScore8 / apiData.length) * 10,
        drilldown: "sem8",
        color: "#644C74",
      },
      {
        name: "Academic Avg.",
        y: (avgscoreAcademic / apiData.length) * 10,
        drilldown: "Academic Avg.",
        color: "#977DA8",
      },
      {
        name: "Credit Avg.",
        y: (avgscoreCredit / apiData.length) * 10,
        drilldown: "Credit Avg.",
        color: "#6D438A",
      },
    ];

    chartsModel.studentStatusChart.options = {
      chart: {
        type: "column",
      },
      title: {
        align: "left",
        text: "Student Compiled Score Analysis",
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        type: "category",
        title: {
          text: 'Semesters',
        },
      },
      yAxis: {
        title: {
          text: "Average Score",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{point.y:.1f}%",
          },
        },
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b><br/>',
      },

      series: [
        {
          name: "Score",
          colorByPoint: true,
          data: studentChartData,
        },
      ],
    };





    // chartsModel.studentStatusChart.data = {
    //     continue: 'Assignments Assigned',
    //     continueColor: '#0e6052',
    //     disContinue: 'Assignments Attended',
    //     disContinueColor: '#01a185',
    //     complete: 'Assignments Not Attended',
    //     completeColor: '#17d5b3'
    // }
    return chartsModel;
  }
}
